import { useActor } from '@xstate/react';

import { useGlobalAppState } from '@order/GlobalAppState';

export const useLastInteractedStoreMachine = () => {
  const { lastInteractedStoreMachineRef } = useGlobalAppState();

  return useActor(lastInteractedStoreMachineRef);
};
